import React, { useState } from 'react';
import PageHeader from '../../components/PageHeader/PageHeader';
import MetricRow from '../../components/MetricRow/MetricRow';
import MetricCard from '../../components/MetricCard/MetricCard';
import Badge from '../../components/Badge/Badge';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import styles from './ResearcherProfile.module.css';

const ResearcherProfile = () => {
  const [showChangePlanModal, setShowChangePlanModal] = useState(false);
  const [showRefundModal, setShowRefundModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState('Pro');
  const [billingCycle, setBillingCycle] = useState('Now, prorated');
  const [refundAmount, setRefundAmount] = useState('₹15,000');
  const [refundReason, setRefundReason] = useState('Participant no-show surplus');

  const headerBadge = <Badge variant="blue">Pro Plan</Badge>;

  const headerActions = (
    <>
      <Button
        variant="secondary"
        onClick={() => setShowChangePlanModal(true)}
      >
        Change plan
      </Button>
      <Button
        variant="secondary"
        style={{ color: '#B3261E' }}
        onClick={() => setShowRefundModal(true)}
      >
        Refund budget
      </Button>
    </>
  );

  const planModalFooter = (
    <>
      <Button variant="secondary" onClick={() => setShowChangePlanModal(false)}>
        Cancel
      </Button>
      <Button variant="primary" onClick={() => setShowChangePlanModal(false)}>
        Update plan
      </Button>
    </>
  );

  const refundModalFooter = (
    <>
      <Button variant="secondary" onClick={() => setShowRefundModal(false)}>
        Cancel
      </Button>
      <Button variant="danger" onClick={() => setShowRefundModal(false)}>
        Process refund
      </Button>
    </>
  );

  return (
    <>
      <PageHeader
        backTo="/researchers"
        backText="← Researchers"
        title="Insight Loop Research"
        badge={headerBadge}
        subtitle="Priya Nair (Lead UX Researcher) · Delhi NCR"
        actions={headerActions}
      />

      <MetricRow columns={4}>
        <MetricCard label="Wallet balance" value="₹42,500" subtext="available" />
        <MetricCard label="Total spend" value="₹8.2L" subtext="lifetime" />
        <MetricCard label="Studies completed" value="14" subtext="2 active" />
        <MetricCard label="KYC status" value="Verified" subtext="GSTIN matched" isGreen />
      </MetricRow>

      <div className={styles.mainGrid}>
        <section className={styles.card}>
          <h2 className={styles.cardTitle}>Recent studies</h2>
          <div className={styles.studyList}>
            <div className={styles.studyRow}>
              <div>
                <div className={styles.studyTitle}>Mobile Gaming Behaviour – Android</div>
                <div className={styles.studySubtitle}>Submitted today · Focus group · 12 seats</div>
              </div>
              <Badge variant="warning">Needs check</Badge>
            </div>
            <div className={styles.studyRow}>
              <div>
                <div className={styles.studyTitle}>HR & IT Manager Opinions</div>
                <div className={styles.studySubtitle}>Active · Online focus group · 6 seats</div>
              </div>
              <Badge variant="success">Live</Badge>
            </div>
            <div className={styles.studyRow}>
              <div>
                <div className={styles.studyTitle}>FinTech App Onboarding Audit</div>
                <div className={styles.studySubtitle}>Completed Aug 14 · 1-on-1 interview · 15 seats</div>
              </div>
              <Badge variant="neutral">Completed</Badge>
            </div>
          </div>
        </section>

        <section className={styles.card}>
          <h2 className={styles.cardTitle}>Organization details</h2>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Legal entity</span>
            <span className={styles.detailValue}>Insight Loop LLP</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>GSTIN</span>
            <span className={styles.detailValue}>07AABCI1234F1Z8</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Billing email</span>
            <span className={styles.detailValue}>accounts@insightloop.in</span>
          </div>
          <div className={styles.detailRow}>
            <span className={styles.detailLabel}>Account manager</span>
            <span className={styles.detailValue}>Nishant K.</span>
          </div>
        </section>
      </div>

      <Modal
        isOpen={showChangePlanModal}
        onClose={() => setShowChangePlanModal(false)}
        title="Change plan"
        footer={planModalFooter}
        maxWidth={480}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '13px' }}>
          <span>Select tier</span>
          <div className={styles.pillGroup}>
            {['Free', 'Pro', 'Agency'].map((plan) => (
              <button
                key={plan}
                type="button"
                onClick={() => setSelectedPlan(plan)}
                className={`${styles.pillBtn} ${selectedPlan === plan ? styles.pillBtnActive : ''}`.trim()}
              >
                {plan}
              </button>
            ))}
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '13px' }}>
          <span>Effective date</span>
          <div className={styles.pillGroup}>
            {['Now, prorated', 'At renewal · Nov 01'].map((cycle) => (
              <button
                key={cycle}
                type="button"
                onClick={() => setBillingCycle(cycle)}
                className={`${styles.pillBtn} ${billingCycle === cycle ? styles.pillBtnActive : ''}`.trim()}
              >
                {cycle}
              </button>
            ))}
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={showRefundModal}
        onClose={() => setShowRefundModal(false)}
        title="Refund budget"
        footer={refundModalFooter}
        maxWidth={480}
      >
        <label style={{ display: 'flex', flexDirection: 'column', gap: '6px', fontSize: '13px' }}>
          <span>Amount to refund</span>
          <input
            value={refundAmount}
            onChange={(e) => setRefundAmount(e.target.value)}
            className={styles.inputField}
          />
        </label>
        <label style={{ display: 'flex', flexDirection: 'column', gap: '6px', fontSize: '13px' }}>
          <span>Reason for refund</span>
          <input
            value={refundReason}
            onChange={(e) => setRefundReason(e.target.value)}
            className={styles.inputField}
          />
        </label>
      </Modal>
    </>
  );
};

export default ResearcherProfile;
